package com.ijoin.data.model

import kotlinx.serialization.Serializable

@Serializable
data class CancelEventRequest(
    val reason: String? = null,
)
